import React from "react"
import game from "tictactoe.png"

const TicTacToe = props => <img src={game} className="game" {...props} />

export default TicTacToe
